module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Ettingen-317a1cfc5b216ea72debcf11df5a7cbe.svg";